import Vue from 'vue'
import Router from 'vue-router'
import CategorySelection from './views/CategorySelection'
import Favourites from './views/Favourites'
import Live from './views/Live.vue'
import LiveLivingOption from './views/LiveLivingOption'
import LivePackages from './views/LivePackages'
import LiveDwellings from './views/LiveDwellings'
import Page from './views/Page.vue'
import Rest from './views/Rest.vue'
import { bus } from './main'
import store from './store'
import VirtualTourStatic from './components/VirtualTourStatic.vue'
Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      name: 'rest',
      path: '/',
      component: Rest
    },
    {
      name: 'virtual-tour',
      path: '/category/:categoryId/virtual-tour',
      component: VirtualTourStatic
    },
    {
      name: 'category-selection',
      path: '/select',
      component: CategorySelection
    },
    {
      name: 'favourites',
      path: '/category/:categoryId/favourites',
      component: Favourites
    },
    {
      name: 'favourite-modal',
      path: '/category/:categoryId/favourites/:favouriteId',
      component: Favourites
    },
    {
      name: 'page',
      path: '/category/:categoryId/page/:pageId',
      component: Page
    },
    {
      name: 'live',
      path: '/category/:categoryId/live',
      component: Live
    },
    
    {
      name: 'masterplan',
      path: '/category/:categoryId/masterplan',
      component: Page
    },
    {
      name: 'masterplan-livingoption',
      path: '/category/:categoryId/masterplan/lo/:livingOptionId',
      component: Page
    },
    {
      name: 'masterplan-subsectiongroup',
      path: '/category/:categoryId/masterplan/sg/:subsectionGroupId',
      component: Page
    },
    {
      name: 'masterplan-subsection',
      path: '/category/:categoryId/masterplan/s/:subsectionId',
      component: Page
    },
    {
      name: 'masterplan-property',
      path: '/category/:categoryId/masterplan/s/:subsectionId/:propertyId',
      component: Page
    },

    {
      name: 'live-page',
      path: '/live/page/:pageId',
      component: Page
    },
    {
      name: 'packages',
      path: '/category/:categoryId/live/packages',
      component: LivePackages
    },
    {
      name: 'package-modal',
      path: '/category/:categoryId/live/packages/:packageId',
      component: LivePackages
    },
    {
      name: 'dwellings',
      path: '/category/:categoryId/live/dwellings',
      component: LiveDwellings
    },
    {
      name: 'dwelling-modal',
      path: '/category/:categoryId/live/dwellings/:dwellingId',
      component: LiveDwellings
    },
    {
      name: 'turnkeys',
      path: '/category/:categoryId/live/turnkeys',
      component: LiveDwellings
    },
    {
      name: 'turnkey-modal',
      path: '/category/:categoryId/live/turnkeys/:propertyId',
      component: Page
    },
    {
      name: 'living-entry',
      path: '/category/:categoryId/live/:pathway',
      component: Page
    },
    {
      name: 'living-option',
      path: '/category/:categoryId/live/:pathway/:livingOptionId',
      component: LiveLivingOption
    },
    {
      name: 'subsection',
      path: '/category/:categoryId/live/:pathway/:livingOptionId/subsection/:subsectionId',
      component: Page
    },
    {
      name: 'property',
      path: '/category/:categoryId/live/:pathway/:livingOptionId/subsection/:subsectionId/property/:propertyId',
      component: Page
    }
  ]
})

// TODO: route guard bottombar visiblilty - is there a better way of doing this?
// TODO: handle skipping category selection better
router.beforeEach((to, from, next) => {
  if (from.name === 'masterplan-livingoption' && to.name === 'masterplan' && store.state.property.livingOptions.length === 1) {
    return next(false)
  }

  if (store.state.lightswarmHost && (from.name === 'masterplan-subsection' || from.name === 'masterplan-property')) {
    if (to.name === 'masterplan-property' || to.name === 'masterplan-subsection') next()
    else store.dispatch('triggerLightswarmAllOn')
  }

  if (to.name === 'masterplan') {
    if (store.state.property.livingOptions.length === 1) {
      return next({ name: 'masterplan-livingoption', params: { livingOptionId: store.state.property.livingOptions[0]._id }})
    }
  }

  if (to.name === 'masterplan-subsectiongroup') {
    const subsectionGroup = store.state.property.subsectionGroups.find(subsectionGroup => subsectionGroup._id === to.params.subsectionGroupId)
    if (subsectionGroup && subsectionGroup.subsections.length === 1) {
      if (from.name === 'masterplan-livingoption') {
        return next({ name: 'masterplan-subsection', params: { subsectionId: subsectionGroup.subsections[0]._id }})
      }
      if (from.name === 'masterplan-subsection') {
        return next({ name: 'masterplan-livingoption', params: { livingOptionId: subsectionGroup.parent.id }})
      }
    }
  }    
  
  if (to.path === '/select') {
    if (store.getters.navigation && store.getters.navigation.length === 1) {
      store.state.isBottomBarVisible = true
      const category = store.getters.navigation[0]
      const defaultChildUrl = store.getters.navigation[0].defaultChildUrl
      const customRouteUrl = store.getters.navigation[0].customRoute
      
      let newTo = ''

      if (customRouteUrl) {
        newTo = customRouteUrl
      } else if (defaultChildUrl) {
        newTo = defaultChildUrl
      } else {
        newTo = `/category/${category._id}/page/${category.children[0].pageId}`
      }
      
      if (from.path === newTo) {
        return next(false)
      } else {
        return next(newTo)
      }
    } else {
      store.state.isBottomBarVisible = false    
      return next()
    }
  } else if (['/'].includes(to.path)) {
    store.state.isBottomBarVisible = false     
    return next()
  } else {
    store.state.isBottomBarVisible = true
    return next()
  }
})

router.afterEach((to) => {
  // store.commit('clearAnimationQueue')
  if (store.state.lightswarmHost) {
    let label
    switch (to.name) {
      case 'masterplan-subsectiongroup':
        // label = store.state.property.subsectionGroups.find(subsectionGroup => subsectionGroup._id === to.params.subsectionGroupId).label
        // store.dispatch('triggerLightswarm', { type: 'section', label: label })
        break;
      case 'masterplan-subsection':
        label = store.state.property.subsections.find(subsection => subsection._id === to.params.subsectionId).label
        store.dispatch('triggerLightswarm', { type: 'floor', label: label })
        break;
      case 'masterplan-property':
        // No individual property lighting? Comment this out.
        // label = store.state.property.properties.find(property => property._id === to.params.propertyId).label
        // store.dispatch('triggerLightswarm', { type: 'propertie', label: label })
        break;
    }
  }

  setTimeout(() => {
    bus.$emit('startAnimations')
  }, 100)
})

export default router
